import { ReactNode, createContext, useMemo } from 'react'

export type EmptyRenderFunction = (fallbackRender: () => ReactNode) => ReactNode

const EmptyContext = createContext<{
  render: EmptyRenderFunction
}>({
  render: (fallbackRender) => fallbackRender(),
})

export interface EmptyProviderProps {
  children: ReactNode
  render: EmptyRenderFunction
}

export const EmptyProvider = ({ render, children }: EmptyProviderProps) => {
  const context = useMemo(() => ({ render }), [render])

  return (
    <EmptyContext.Provider value={context}>{children}</EmptyContext.Provider>
  )
}

const fallbackRenderer = () => null

export const EmptySlot = ({ children }: { children?: () => ReactNode }) => {
  return (
    <EmptyContext.Consumer>
      {({ render }) => render(children ?? fallbackRenderer)}
    </EmptyContext.Consumer>
  )
}
